export default "__VITE_ASSET__BbOPQ8TZ__"